export default "<div class=\"T_O-auth-container\">\r\n  <router-outlet></router-outlet>\r\n\r\n\r\n</div>\r\n"